import { Tooltip, Typography } from "@mui/material";
import formatter from "../../../tools/formatter.js";
import { DealBuilder } from "../../services/deal-builder.ts";

interface NewTicDisplayProps {
  builder: DealBuilder
}

export default function NewTicDisplay({ builder }: NewTicDisplayProps) {
  
  const showExpensesTic = builder.ticExpenses !== 0 && builder.ticExpenses !== undefined;
  
  return (
    <Typography 
      variant="subtitle2" 
      fontWeight={400}
      lineHeight="30px"
    >
      TIC:{" "} 
      <Tooltip title="True Interest Cost">
        <b style={{ "borderBottom": "2px dotted gray", "fontWeight": 400 }}>
          {builder.tic ? formatter.percent(builder.tic, 2) : "?"}
        </b>
      </Tooltip>
      {showExpensesTic && (
        <>
          {" "}/{" "} 
          <Tooltip title="Expenses Adjusted True Interest Cost">
            <b style={{ "borderBottom": "2px dotted gray", "fontWeight": 400 }}>
              {builder.adjustedTic ? formatter.percent(builder.adjustedTic, 2) : "?"}
            </b>
          </Tooltip>
        </>
      )}
    </Typography>
  )

}
